import { render, staticRenderFns } from "./MySpaceRemindersSummaryWidget.vue?vue&type=template&id=98c09684&"
import script from "./MySpaceRemindersSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./MySpaceRemindersSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports